export const EMPTY_PAYMENT_WALLETS = { btc: "", usdt: "" };

export const PAYMENT_WALLET_META = {
  btc: { name: "Bitcoin", symbol: "BTC", network: "Bitcoin", color: "orange" },
  usdt: { name: "USDT (TRC20)", symbol: "USDT", network: "Tron TRC20", color: "teal" },
};

const BTC_PATTERN = /^(?:bc1[ac-hj-np-z02-9]{11,71}|[13][a-km-zA-HJ-NP-Z1-9]{25,61})$/;
const TRON_PATTERN = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;

export const isPaymentWalletValid = (type, value) => {
  const address = (value || "").trim();
  if (type === "btc") return BTC_PATTERN.test(address);
  if (type === "usdt") return TRON_PATTERN.test(address);
  return false;
};

export const normalizePaymentWallets = (wallets = {}) => ({
  btc: (wallets.btc || "").trim(),
  usdt: (wallets.usdt || "").trim(),
});